import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfigService } from '../services/config.service';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  public cartData: any;
  baseUrl!: String;
  private parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  private searchKeySubject = new BehaviorSubject<string>('');
  searchKey$ = this.searchKeySubject.asObservable();
  private searchTerm: string = '';

  constructor(private http: HttpClient,
    private configService: ConfigService) {
    this.baseUrl = this.configService.getBaseUrl();

  }

  dayCountForReports: number = 3;

  setSearchKey(key: string) {
    this.searchKeySubject.next(key);
  }

  setSearchTerm(term: string) {
    this.searchTerm = term;
  }

  getSearchTerm(): string {
    return this.searchTerm;
  }

  public getLoginDetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? '{}');
  }

  public getThirdPartyConnectionDetails() {
    let userDetails = this.getLoginDetails();
    return JSON.parse(userDetails?.ThirdPartyConnectionDetails ?? 'null');
  }

  public getDiscountAmountFromPerc(precent: string, unitPrice: number): number {
    return Math.round(unitPrice * (Number(precent) / 100));
  }

  public getDiscountPrecFromAmount(amount: string, unitPrice: number): number {
    return Math.round((Number(amount) / unitPrice) * 100);
  }

  public getProductDiscount(product: any): number {
    return (
      ((product.UnitPrice - product.FinalPrice) / product.UnitPrice) * 100
    );
  }


  public getProductMRPDiscount(product: any): number {
    return ((product.MRP - product.FinalPrice) / product.MRP) * 100;
  }

  public toDateString(date: any) {
    return moment(date).format('yyyy-MM-DDTHH:mm:ss.sss')
  }

  public convertUnixDateFormat(date: any) {
    return moment.unix(date).format("DD MMM YY, hh:mm a");
  }

  public convertDateFormatDetails(date: any) {
    return moment.utc(date, "YYYY-MM-DDTHH:mm:ss").local().format("DD MMM YY, hh:mm a");
  }

  public GenerateOTPforseller() {
    let userDetails = this.getLoginDetails();
    var url = this.configService.getNoAuthUrl() + '/User/GenerateOTPForAdminUser?adminUsername=' + userDetails.UserName;
    return this.http.get(url, this.parseHeaders)
  }

  public getDatesForReport() {
    let dates: any = {};
    dates.from = moment().startOf('month');
    dates.to = moment();
    let dayDifference = moment().diff(dates.from, 'days');
    if (dayDifference < this.dayCountForReports) {
      dates.from = moment().subtract(1, 'months').startOf('month');
      dates.to = moment().subtract(1, 'months').endOf('month');
    }
    dates.yearRange = `2010:${new Date().getFullYear()}`  //year range will be [2010 - current year]
    dates.today = moment().toDate();
    dates.from = moment(dates.from).toDate();
    dates.to = moment(dates.to).toDate();
    return dates;
  }

  public saveLoginCredentials(adminDetails: any, tokenDetails?: any) {
    localStorage.setItem("sellerUuid", adminDetails?.Uuid);
    this.configService.sellerDetails = adminDetails;
    if (tokenDetails) {
      this.persistAccessToken(tokenDetails);
    }
    localStorage.setItem("admin_Details", JSON.stringify(adminDetails));
    localStorage.setItem("userType", JSON.stringify(adminDetails?.UserType));
  }

  public persistAccessToken(tokenDetails: any) {
    let refreshToken: any = null;
    if (tokenDetails?.token) {
      refreshToken = tokenDetails;
    } else if (tokenDetails?.accessToken) {
      const presistTokenDetails = localStorage.getItem('tokenDetails');
      if (presistTokenDetails && presistTokenDetails !== "") {
        refreshToken = JSON.parse(presistTokenDetails);
      } else {
        refreshToken = { 'token': '' };
      }
      refreshToken.token = tokenDetails.accessToken;
    }
    localStorage.setItem("tokenDetails", JSON.stringify(refreshToken));
  }

  public getSubCategories(parentCategoryID: any) {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Products/GetSubCategories?SellerID=' + 0 + '&ParentCategoryID=' + parentCategoryID;
    return this.http.get(url, this.parseHeaders);
  }

  public getProductDetails(productId: number) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: productId,
      // userID: userDetails.UserID,
      sellerID: 0,
      productsFor: 'admin',
    };
    let url = this.baseUrl + '/Products/GetProductDetailsVTwo';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public saveProductVariants(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      updatedBy: Number(userDetails.UserID),
      variantGroup: params.variantGroup,
    }
    let url = this.baseUrl + '/Products/SaveProductVariants';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public addProduct(params: any) {
    let userDetails = this.getLoginDetails();
    let ProductSeoData = {
      ProductSeokeywords: params.SeoKeywords
    }

    let ExternalProductsLinks = {
      ExternalProductLink: params.ExternalProductLink
    }

    let sendingData = {
      createdBy: Number(userDetails.UserID),
      updatedBy: Number(userDetails.UserID),
      sellerID: 0,

      name: params.name,
      description: params.description,
      categoryID: params.categoryID,
      searchKeywords: params.searchKeywords,
      autoOutOfStock: params.autoOutOfStock,
      stock: params.stock,
      productWeight: params.productWeight,

      unitPrice: params.unitPrice,
      purchasePrice: params.purchasePrice ?? 0,
      mrp: this.configService.sellerConfiguration.ShowMRP ? params.mrp : params.unitPrice,
      discount: params.discount,
      mrpDiscount: params.mrpDiscount,
      sellerPriceConfig: params.sellerPriceConfig,  // "string",
      resellingPriceConfig: params.resellingPriceConfig,  // "string",
      cgst: Number(params.cgst),  // 0,
      sgst: Number(params.sgst),  // 0
      isReselling: params.isReselling,

      image: params.image,
      multiImages: JSON.stringify(params.multiImages),

      isItemVariant: params.isItemVariant,
      currentVariantData: params.currentVariantData,
      productVariants: params.productVariants,
      parentProductId: params.parentProductId,
      hasVariants: params.hasVariants,
      variantGroup: params.variantGroup,
      modificationNotificationConfig: params.modificationNotificationConfig,
      isProductPublished: params.isProductPublished,
      productSeoData: JSON.stringify(ProductSeoData),
      externalLinks: JSON.stringify(ExternalProductsLinks),
      deliveryChargeProductID: params.deliveryChargeProductID,
      productTag: params.productTag ?? "",
      additionalInfo: params.additionalInfo,
      "customDetails": "",
      "subCategoryID": "0",
      "unitName": "",

    };
    let url = this.baseUrl + '/Products/AddProduct';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public addProductwithVarients(params: any) {
    let ProductSeoData = {
      ProductSeokeywords: params.SeoKeywords
    }
    let ExternalProductsLinks = {
      ExternalProductLink: params.ExternalProductLink
    }
    let userDetails = this.getLoginDetails();
    let sendingData = {
      createdBy: userDetails.UserID,
      updatedBy: userDetails.UserID,
      sellerID: 0,
      name: params.name,
      unitPrice: params.unitPrice,
      mrp: params.mrp ?? 0,
      discount: params.discount ?? 0,
      description: params.description,
      image: params.image ?? '',
      categoryID: params.categoryID,
      searchKeywords: params.searchKeywords ?? '',
      autoOutOfStock: params.autoOutOfStock ?? false,
      multiImages: params.multiImages,
      stock: params.stock ?? 0,
      customDetails: '',
      subCategoryID: '0',
      unitName: '',
      isItemVariant: params.isItemVariant,
      parentProductId: params.parentProductId ?? '',
      currentVariantData: params.currentVariantData,
      productVariants: params.productVariants,
      productSeoData: JSON.stringify(ProductSeoData),
      externalLinks: JSON.stringify(ExternalProductsLinks),
      additionalInfo: params.additionalInfo,
      productTag: params.productTag ?? "",
    };
    let url = this.baseUrl + '/Products/AddProductWithVariants';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateProduct(params: any) {
    let userDetails = this.getLoginDetails();
    let ProductSeoData = {
      ProductSeokeywords: params.SeoKeywords
    }
    let ExternalProductsLinks = {
      ExternalProductLink: params.ExternalProductLink
    }
    let sendingData = {
      sellerID: 0,
      updatedBy: userDetails.UserID,
      updatedOn: new Date(),

      id: params.id,
      name: params.name,
      unitPrice: params.unitPrice,
      purchasePrice: params.purchasePrice ?? 0,
      mrp: params.mrp,
      discount: params.discount ?? 0,
      mrpDiscount: params.mrpDiscount ?? 0,
      description: params.description,
      image: params.image,
      multiImages: JSON.stringify(params.multiImages),
      searchKeywords: params.searchKeywords,
      autoOutOfStock: params.autoOutOfStock,
      categoryID: params.categoryID,

      "customDetails": "",
      "unitName": "",
      stock: params.stock,
      productWeight: params.productWeight,
      deliveryChargeProductID: params.deliveryChargeProductID,

      currentVariantData: params.currentVariantData,
      productVariants: params.productVariants,
      parentProductId: params.parentProductId ?? 0,
      isItemVariant: false,

      sellerPriceConfig: params.priceCalcValues,
      resellingPriceConfig: params.resellingPriceConfig,
      cgst: params.cgst,
      sgst: params.sgst,
      modificationNotificationConfig: params.modificationNotificationConfig,
      isReselling: params.isReselling,
      isProductPublished: params.isProductPublished,
      productSeoData: JSON.stringify(ProductSeoData),
      externalLinks: JSON.stringify(ExternalProductsLinks),
      additionalInfo: params.additionalInfo,
      productTag: params.productTag ?? "",
    };
    let url = this.baseUrl + '/Products/UpdateProduct';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public saveProductChangeRequest(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      createdBy: userDetails.UserID,
      requestedSellerKey: userDetails?.SellerUniqueKey ?? "",
      sellerId: params.sellerId,
      id: params.id,
      productId: params.productId,
      requestStatus: params.requestStatus,
      productName: params.productName,
      previousData: params.previousData,
      modifiedData: params.modifiedData,
    }
    let url = this.baseUrl + '/Products/SaveProductChangeRequest';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getProductList(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      categoryID: params.categoryID,
      keyword: params.keyword,
      productsFor: params.productsFor,
      organisationID: params.OrganisationID,
      sellerID: 0,
      showInactiveProductsOnly: params.ShowInactiveProductsOnly ?? false,
      showUnpublishedProductsOnly: params.ShowUnpublishedProductsOnly ?? false,
      showOutofStockProductsOnly: params.showOutOfStockProductsOnly ?? false,
      productTag: params.productTag ?? '',
      // userId: userDetails.UserID,
    };
    var url = this.baseUrl + '/Products/GetProducts';
    return this.http.post(url, sendingData, this.parseHeaders);
  }
    public getServiceProductList(params: any) {
    let sendingData = {
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      categoryID: params.categoryID,
      keyword: params.keyword,
      productsFor: params.productsFor,
      productsType: params.productsType,
      organisationID: params.OrganisationID,
      showInactiveProductsOnly: params.ShowInactiveProductsOnly ?? false,
      showUnpublishedProductsOnly: params.ShowUnpublishedProductsOnly ?? false,
      showOutofStockProductsOnly: params.ShowOutOfStockProductsOnly ?? false,
      IncludeBatches: params.IncludeBatches ?? false,
      productTag: params.productTag ?? '',
    }
    var url = this.baseUrl + '/Products/GetProducts'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public pdatePriceOfBulkItems(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData: any[] = [];
    let product = {
      updatedBy: userDetails.UserID,
      sellerID: 0,
      productID: 0,
      price: 0,
      mrp: 0,
      discount: 0,
      selected: true,
      stock: 0,
    };
    params.map((item: any) => {
      product.productID = item.ID ?? 0;
      product.price = item.newUnitPrice ?? item.UnitPrice;
      product.mrp = item.newMRP ?? item.MRP;
      product.discount = item.Discount ?? 0;
      product.stock = item.Stock ?? 0;
      let prod = JSON.parse(JSON.stringify(product));
      sendingData.push(prod);
    });
    let url = this.baseUrl + '/Products/UpdatePriceOfBulkItems';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateStockOfBulkItems(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData: any[] = [];
    let product = {
      updatedBy: userDetails.UserID,
      sellerID: 0,
      productID: 0,
      currentStock: 0,
      updatedStock: 0,
      unitPrice: 0,
      mrp: 0,
      discount: 0,
      purchasePrice: 0,
    };
    params.map((item: any) => {
      (product.productID = item.ID),
        (product.updatedStock =
          item.newStock != '' ? parseInt(item.newStock) : item.Stock);
      product.currentStock = item.Stock;
      product.unitPrice = item.UnitPrice ?? 0;
      product.mrp = item.MRP ?? 0;
      product.discount = item.Discount ?? 0;
      product.purchasePrice = item.PurchasePrice ?? 0;
      let prod = JSON.parse(JSON.stringify(product));
      sendingData.push(prod);
    });
    let url = this.baseUrl + '/Products/UpdateStockOfBulkItems';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getDashboardTotalBySeller(params:any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
    };
    let url = this.baseUrl + '/Seller/GetDashboardTotalBySeller';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getNonDeliveredOrders(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      organisationID: params.organisationID,
      forAdmin: params.forAdmin,
    };
    let url = this.baseUrl + '/Order/GetNonDeliveredOrders';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteProduct(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      updatedBy: userDetails.UserID,
      sellerID: 0,
      id: params.id,
      variantGroup: params.variantGroup
    };
    let url = this.baseUrl + '/Products/DeleteProduct';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public setProductOutOfStock(params: any) {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Products/SetProductOutOfStock';
    let sendingData = {
      ID: params.ID,
      Status: params.Status,
      SellerID: 0,
      UpdatedBy: userDetails.UserID,
    };
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public changeProductStatus(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      ID: params.ID,
      Status: params.Status,
      SellerID: 0,
      UpdatedBy: userDetails.UserID,
    };
    let url = this.baseUrl + '/Products/ChangeProductStatus';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllSellers(params: any) {
    let sendingData = {
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      takeSellers: params.takeSellers,
      takeReSellers: params.takeReSellers,
      searchKey: params.searchKey
    }
    let url = this.baseUrl + '/Seller/GetAllSellers';
    return this.http.post(url, sendingData, this.parseHeaders);
  }


  public ProductPublishUnpublish(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      ID: params.ID,
      Status: params.Status,
      SellerID: 0,
      UpdatedBy: userDetails.UserID
    };
    let url = this.baseUrl + '/Products/ChangeProductPublishUnpublish';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateProductStock(param: any) {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Purchase/UpdateProductStock';
    let sendingData = {
      productID: param.productID,
      stock: param.stock,
      updatedBy: userDetails.UserID,
    };
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public createDamage(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      price: params.price,
      productId: params.productId,
      qty: params.qty,
      damageDescription: params.damageDescription,
      createdBy: userDetails.UserID,
      createdOn: new Date(),
      productName: params.productName,
      sellerID: 0,
      damageType: '',
    };
    let url = this.baseUrl + '/DamageProduct/CreateDamageProduct';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getProductStockHistory(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      productID: params.productID,
      organisationID: userDetails.OrganisationID,
    };
    let url = this.baseUrl + '/Products/GetProductStockHistory';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSellerThemeDetailsBySellerId() {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      createdBy: userDetails.UserID,
    };
    let url =
      this.baseUrl + '/Seller/GetSellerThemeDetailsBySellerId';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public GetLandingSiteDetails() {
    let SELLERID = this.getLoginDetails().SellerID;
    const url = this.baseUrl + "/Seller/GetLandingSiteDetails?SellerID=" + 0;
    return this.http.get(url);
  }

  public updateSellerThemeDetails(params: any) {
    let userDetails = this.getLoginDetails();

    params.updatedBy = userDetails.UserID;
    let url = this.baseUrl + '/Seller/UpdateSellerThemeDetails';
    return this.http.post(url, params, this.parseHeaders);
  }

  // FOR CENTRALIZED MULTIPLE SELLER SETTINGS UPDATION - can be used for any update where we are sending multiple params and not all params are mandatory. We can send only the params which are required for that particular update and avoid sending null or undefined values for other params.
  // public updateSellerThemeDetails(params: any) {
  //   let userDetails = this.getLoginDetails();

  //   params.updatedBy = userDetails.UserID;

  //   let payload: any = {
  //     sellerID: 0
  //   };

  //   const jsonFields = [
  //     'isPublished',
  //     'updatedBy',
  //     'isDummyEnabled',
  //     'showLandingSiteFirst',
  //     'thirdPartySettings',
  //     'loyaltySettings',
  //     'menuCardSettings',
  //     'dvCardSettings',
  //     'deliveryChargeSettings',
  //     'sellerThemeDetails'
  //   ];

  //   jsonFields.forEach((key: any) => {
  //     if (params?.[key] !== undefined && params?.[key] !== null) {
  //       payload[key] = params[key];
  //     }
  //   });
  //   let url = this.baseUrl + '/Seller/UpdateSellerThemeDetails';
  //   return this.http.post(url, payload, this.parseHeaders);
  // }

  public SaveLandingSiteData(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      ID: params.id || 0,
      SellerID: 0,
      CustomerCare: params.customerCare,
      Address: params.address,
      Email: params.email,
      PhoneNumber: params.phoneNumber,
      SubDomain: userDetails.subDomain,
      IsSitePublished: params.isSitePublished,
      WebsiteTheme: params.websitetheme,
      SliderTitle: params.sliderTitle,
      SliderHeading: params.sliderHeading,
      SiteSubHeading: params.siteSubHeading,
      MainBannerMarginTop: params.mainBannerMarginTop,
      MainBannerHeight: params.mainBannerHeight,
      SecondaryBannerMarginTop: params.secondaryBannerMarginTop,
      SecondaryBannerHeight: params.secondaryBannerHeight,
      MobileMainBannerMarginTop: params.mobilemainBannerMarginTop,
      MobileMainBannerHeight: params.mobilemainBannerHeight,
      MobileSecondaryBannerMarginTop: params.mobilesecondaryBannerMarginTop,
      MobileSecondaryBannerHeight: params.mobilesecondaryBannerHeight,
      SliderDescription: params.sliderDescription,
      SiteSubDescription: params.siteSubDescription,
      WebsiteLogoSecondary: params.websitelogosecondary,
      WebsiteBannerImage: params.websiteBannerImage,
      SecondaryWebsiteBannerImage: params.secondarywebsiteBannerImage,
      WorkingFlowDataHeading: params.workingFlowDataHeading,
      MenuworkingFlowDataHeading: params.menuworkingFlowDataHeading,
      WorkingFlowDataDescription: params.workingFlowDataDescription,
      aboutSectionHeading: params.aboutSectionHeading,
      aboutHead: params.aboutHead,
      aboutDescription: params.aboutDescription,
      aboutImage: params.aboutImage,
      uspSectionHead: params.uspSectionHead,
      UspSectionTitle: params.uspSectionTitle,
      UspSectionDescription: params.uspSectionDescription,
      uspImage: params.uspImage,
      FeturesHeading: params.feturesHeading,
      MenuFeturesHeading: params.menufeturesHeading,
      FeturesDescription: params.feturesDescription,
      SubscriptionHeading: params.subscriptionHeading,
      MenuSubscriptionHeading: params.menusubscriptionHeading,
      SubscriptionDescription: params.subscriptionDescription,
      FaqHeading: params.faqHeading,
      FaqTitle: params.faqTitle,
      MenuFaqHeading: params.menufaqHeading,
      FaqDescription: params.faqDescription,
      faqImage: params.faqImage,
      ScreenShotHeading: params.screenShotHeading,
      MenuScreenShotHeading: params.menuscreenShotHeading,
      ScreenShotDescription: params.screenShotDescription,
      InitialNavigationDescription: params.initialNavigationDescription,
      InitialNavigationHeading: params.initialNavigationHeading,
      FooterHeading: params.footerHeading,
      FooterDescription: params.FooterDescription,
      HelpVideoHeading: params.helpVideoHeading,
      MenuHelpVideoHeading: params.menuhelpVideoHeading,
      HelpVideDescription: params.helpVideDescription,
      helpvideoSectionHead: params.helpvideoSectionHead,
      Color: params.color,
      SecondaryColor: params.secondaryColor,
      SubscriptionPlanDetails: params.subscriptionPlanDetails,
      Features: params.features,
      usps: params.usps,
      abouts: params.abouts,
      customLinks: params.customLinks,
      FAQs: params.faQs,
      HelpVideos: params.helpVideos,
      ScreenshotImages: params.screenshotImages,
      Socialmedia_links: params.socialmedia_links,
      BannerImages: params.bannerImages,
      WorkingFlowSteps: params.workingFlowSteps,
      SiteDetails: params.siteDetails,
      TermsAndConditions: params.termsAndConditions,
      PrivacyPolicy: params.privacyPolicy,
      IsFeatures: params.isFeatures,
      IsPricing: params.isPricing,
      IsFAQs: params.isFAQs,
      IsContactUs: params.isContactUs,
      IsHelpVideo: params.isHelpVideo,
      IsScreenShotImage: params.isScreenShotImage,
      IsWorkingFlow: params.isWorkingFlow,
      isabout: params.isabout,
      isusp: params.isusp,
      UpdatedBy: userDetails.UserID,
      CreatedBy: params.createdBy || userDetails.UserID,
    };

    let sendingDataString = JSON.stringify(sendingData);


    let payload = {
      landingSiteData: sendingDataString
    };

    const url = `${this.baseUrl}/Seller/SaveLandingSiteData`;
    return this.http.post(url, payload, this.parseHeaders);
  }

  public updateSellerProfile(params: any) {
    let userDetails = this.getLoginDetails();
    const socialMediaLinks = {
      facebook: params.facebook,
      youtube: params.youtube,
      gmail: params.gmail,
      customerCareGmail: params.customerCareGmail,
      instagram: params.instagram,
      googleBusiness: params.googleBusiness,
      externalWebsite: params.externalWebsite
    };
    const sendingData = {
      sellerID: 0,
      updatedBy: userDetails.UserID,
      sellerName: params.sellerName,
      customerCare: params.customerCare,
      city: params.district,
      address: params.address,
      socialMediaLinks: JSON.stringify(socialMediaLinks),
      gstNumber: params.gstNumber,
      // companyLogo: params.companyLogo,
      addressline1: params.addressLine1,
      state: params.state,
      country: params.country,
      pincode: params.pincode,
    }
    let url = this.baseUrl + '/Seller/UpdateSellerProfile';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSellerBanks() {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      createdBy: userDetails.UserID
    };
    let url = this.baseUrl + '/Seller/getThirdPartyBanks';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // get seller profile
  public getSellerDetails() {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      createdBy: userDetails.UserID,
    };
    let url = this.baseUrl + '/Seller/GetSellerProfile';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // add account details
  public createBankFromThirdParty(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      createdBy: userDetails.UserID,

      accountHolderName: params.accountHolderName,
      accountHolderAlias: params.accountHolderAlias,
      accountNumber: params.accountNumber,
      bankName: params.bankName,
      branch: params.branch,
      ifsc: params.ifsc,

      verifiedFiles: '',

      // "appName": "string",
      // "hashString": "string",
      // "orgKey": "string",
      // "orgIdentifier": "string",

      // "id": 0,
      // "organizationName": "string",
    };
    let url = this.baseUrl + '/Seller/CreateBankFromThirdParty';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // edit account details
  public updateBankForPaymentGateway(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      id: params.id,
      accountHolderAlias: params.accountHolderAlias,
      accountNumber: params.accountNumber,
      bankName: params.bankName,
      accountHolderName: params.accountHolderName,
      branch: params.branch,
      ifsc: params.ifsc,
      verifiedFiles: params.verifiedFiles,
    };
    let url = this.baseUrl + '/Seller/UpdateBankForPaymentGateway';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // set default account
  public updateDefaultBankStatusFromThirdParty(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      bankId: params.bankId,
      verificationStatus: params.verificationStatus,
    };
    let url =
      this.baseUrl + '/Seller/updateDefaultBankStatusFromThirdParty';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // delete account
  public updateDeletedBankStatusFromThirdParty(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      bankId: params.bankId,
      verificationStatus: params.verificationStatus,
    };
    let url =
      this.baseUrl + '/Seller/updateDeletedBankStatusFromThirdParty';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getCategories() {
    let userDetails = this.getLoginDetails();
    let url =
      this.baseUrl +
      '/Products/GetCategories?SellerID=' +
      0;
    return this.http.get(url);
  }

  public addCategory(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      createdBy: userDetails.UserID,
      sellerID: 0,
      parentCategoryID: params.parentCategoryID,
      name: params.name,
      parentCategoryName: params.parentCategoryName,
      description: params.description,
      icon: params.icon,
      sortOrder: params?.sortOrder,
    };
    let url = this.baseUrl + '/Products/AddCategory';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateCategory(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: params?.ID,
      createdBy: userDetails?.UserID,
      sellerID: userDetails?.SellerID,
      parentCategoryID: params?.parentCategoryID,
      name: params?.name,
      parentCategoryName: params?.parentCategoryName,
      description: params.description,
      icon: params?.icon,
      sortOrder: params?.sortOrder,
    };
    let url = this.baseUrl + '/Products/UpdateCategory';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteCategory(param: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: param.categoryId,
      sellerID: 0,
      updatedBy: userDetails.UserID,
      updatedOn: new Date(),
      isDeleteProducts: param.isDeleteProducts ?? false

    }
    let url = this.baseUrl + '/Products/DeleteCategory';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public moveProductsToSelectedCategory(param: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      fromCategoryID: param.fromCategoryID,
      toCategoryID: param.toCategoryID,
      sellerID: 0,
      updatedBy: userDetails.UserID,
      updatedOn: new Date(),
    }
    let url = this.baseUrl + '/Products/MoveProductsToSelectedCategory';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getProductVariantTypeMasters(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      categoryId: params.categoryId,
      variantTypeFor: params.variantTypeFor,
    };
    let url =
      this.baseUrl + '/Products/GetProductVariantTypeMasters';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public createProductVariantTypeMaster(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      createdBy: Number(userDetails.UserID),
      sellerId: 0,
      id: Number(params.id),
      categoryId: params.categoryId,
      variantType: params.variantType,
      variantTypeFor: params.variantTypeFor,
    };
    let url =
      this.baseUrl + '/Products/CreateProductVariantTypeMaster';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateProductVariantTypeMaster(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      createdBy: Number(userDetails.UserID),
      sellerId: 0,
      id: params.id,
      categoryId: params.categoryId,
      variantType: params.variantType,
      variantTypeFor: params.variantTypeFor,
    };
    let url =
      this.baseUrl + '/Products/UpdateProductVariantTypeMaster';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteProductVariantTypeMaster(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: params.id,
      updatedBy: Number(userDetails.UserID),
    };
    let url =
      this.baseUrl + '/Products/DeleteProductVariantTypeMaster';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public GetSellerCategorySettings() {
    let userDetails = this.getLoginDetails();
    let url =
      this.baseUrl +
      '/Seller/GetSellerCategorySettings?sellerCat=' +
      userDetails.SellerCategory;
    return this.http.get(url, this.parseHeaders);
  }

  public getVariantTypeMastersByVariantTypeFor(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      SellerCategory: userDetails.SellerCategory,
      variantTypeFor: params.variantTypeFor,
    };
    let url =
      this.baseUrl +
      '/Products/GetVariantTypeMastersByVariantTypeFor';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public changePassword(parms: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      userId: userDetails.UserID,
      updatedBy: userDetails.UserID,
      password: parms.password,
      oldPassword: parms.oldPassword,
      phoneNumber: userDetails.UserName,
      otp: parms.otp
    };
    let url = this.baseUrl + '/User/ChangeAdminPasswordUsingOTP';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllOffers(offerType: string) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      offerType: offerType,
    };
    let url = environment.offersURL + '/offer/getAllOfferWithAllOfferRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllConnectedOfferWithAllOfferRule() {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();

    let sendingData = {
      appId: environment.appId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
    };
    let url =
      environment.offersURL + '/offer/getAllConnectedOfferWithAllOfferRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getOfferDetails(offerid: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      offerId: offerid,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
    };
    let url = environment.offersURL + '/offer/getOfferWithAllOfferRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getProductName(id: any) {
    let url =
      this.baseUrl + '/Products/GetProductNameById?productId=' + id;
    return this.http.get(url, this.parseHeaders);
  }

  public getCategoryName(id: any) {
    let url =
      this.baseUrl +
      '/Products/GetCategoryNameById?categoryId=' +
      id;
    return this.http.get(url, this.parseHeaders);
  }

  public getPartnerOfferDetails(offerid: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      offerId: offerid,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
    };
    let url =
      environment.offersURL + '/offer/getConnectedOfferWithAllOfferRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteOfferwithAllOfferRule(offerId: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      updatedBy: Number(loginDetails.UserID),
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      appId: environment.appId,
      id: Number(offerId),
      // offerId: Number(offerId),
      // ruleId: 0,
    };
    let url = environment.offersURL + '/offer/deleteOfferwithAllOfferRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public activateOfferwithAllOfferRule(offerId: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      updatedBy: Number(loginDetails.UserID),
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      appId: environment.appId,
      id: Number(offerId),
      // offerId: 0,
      // ruleId: 0,
    };
    let url = environment.offersURL + '/offer/activateOfferwithAllOfferRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getofferReport(Params: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      offerId: Params.offerId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      mainRuleId: Params.mainRuleId,
      toDate: Params.toDate,
      fromDate: Params.fromDate,
      isDateCheck: Params.isDateCheck,
    };
    let url = environment.offersURL + '/offer/getofferReport';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public createOrUpdateOfferWithRule(params: any, offerRule: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      createdBy: loginDetails.UserID,
      updatedBy: loginDetails.UserID,
      createdOrganizationDetails: JSON.stringify(loginDetails),

      offerName: params.offerName,
      offerCode: params.offerCode,
      offerDescription: params.offerDescription,
      termsAndConditions: params.termsAndConditions,
      isCashbackOffer: params.isCashbackOffer,
      isCrossSellingOffer: params.isCrossSellingOffer,
      isUseWithOther: params.isUseWithOther,

      id: params.id,
      dateValidityEnabled: params.dateValidityEnabled,
      startTime: params.startTime,
      endTime: params.endTime,
      usedCount: params.usedCount,
      offerRule: offerRule, //array
      offerRedeemCriteria: params.offerRedeemCriteria,

      isReward: params.isReward,
      numberOfValidityDays: params.numberOfValidityDays,
    };
    let url = environment.offersURL + '/offer/createOrUpdateOfferWithRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllOfferswithNorules(Params: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      // userId: loginDetails.UserID,
      appId: environment.appId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      showCashbackOffers: Params.showCashbackOffers,
      showNonCashbackOffers: Params.showNonCashbackOffers,
    };
    let url = environment.offersURL + '/offer/getAllOffers';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  getAllOfferItemhead() {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
    };
    let url = environment.offersURL + '/offer/getAllOfferItemhead';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllCrossSellingOfferByAppIdAndOrgId() {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
    };
    let url =
      environment.offersURL + '/offer/getAllCrossSellingOfferByAppIdAndOrgId';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getOfferCodeExistCheck(code: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      offerCode: code,
    };
    let url = environment.offersURL + '/offer/getOfferCodeExistCheck';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public insertOrReplaceFile(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: userDetails.SellerID,
      id: params.id ?? 0,
      bannerImage: params.bannerImage,
      bannerFor: params.bannerFor,
      updatedBy: userDetails.UserID,
      createdBy: userDetails.UserID,
    }
    let url = this.baseUrl + '/Seller/InsertOrUpdateStoreBanner';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getOfferImges() {
    let userDetails = this.getLoginDetails();
    let url =
      this.baseUrl +
      '/Seller/GetOfferImagesBySeller?SellerID=' +
      0;
    return this.http.get(url);
  }

  deleteOfferImage(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      updatedBy: userDetails.UserID,
      id: params.id,
      bannerImageUrl: params.bannerImageUrl,
    };
    let url = this.baseUrl + '/Seller/DeleteOfferBanner';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getUserList() {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      userType: 'user',
      keyWord: '',
    };
    let url = this.baseUrl + '/User/GetUsers';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllUserDeviceLog(params: any) {
    let loginDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: Number(loginDetails.SellerID),
      reportSeekingUserId: Number(loginDetails.UserID),
      reportFor: 'admin',
      userId: params.userId,
      key: params.key,
      page: params.page,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      productId: params.productId,
      // fromDate: moment(params.fromDate, 'yyyy-MM-ddThh:mm:ss').add(1, 'day'),
      // toDate: moment(params.toDate, 'yyyy-MM-ddThh:mm:ss').add(1, 'day'),
    };
    let url = this.baseUrl + '/User/GetAllUserDeviceLog';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteOfferMainRuleWithSubRule(params: any) {
    let loginDetails = this.getLoginDetails();
    let thirtData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      appId: environment.appId,
      updatedBy: Number(loginDetails.UserID),
      orgId: thirtData?.OfferPlatformId ?? loginDetails.SellerID,
      id: params.id,
      ruleId: params.ruleId,
      offerId: params.offerId,
      // offerId: 0,
    };
    let url = environment.offersURL + '/offer/deleteOfferMainRuleWithSubRule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // zip code

  public getZipCodes() {
    const loginDetails = this.getLoginDetails();
    const url = this.baseUrl + '/Seller/GetDeliveryPincodesBySeller';
    const sendingData = { sellerID: loginDetails.SellerID };
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public addZipCode(params: any) {
    const loginDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: loginDetails.SellerID,
      pincode: params.pincode,
      place: params.place,
      createdBy: loginDetails.UserID,
    };
    const url = this.baseUrl + '/Seller/AddDeliveryPincodes';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateZipCode(params: any) {
    const loginDetails = this.getLoginDetails();
    const sendingData = {
      ID: params.id,
      pincode: params.updatedPincode,
      place: params.updatedPlace,
      updatedBy: loginDetails.UserID,
    };
    const url = this.baseUrl + '/Seller/UpdateDeliveryPincodes';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public manageZipCodeStatus(params: any) {
    const loginDetails = this.getLoginDetails();
    const sendingData = {
      ID: params.id,
      status: params.status,
      updatedBy: loginDetails.UserID,
    };
    const url =
      this.baseUrl + '/Seller/ChangeStatusOfDeliveryPincodes';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  //disabled products

  public disabledProductListing() {
    const loginDetails = this.getLoginDetails();
    const sendingData = {
      key: '',
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: true,
      fromDate: '',
      toDate: '',
      sellerID: loginDetails.SellerID,
      organisationID: 0,
      createdBy: 0,
    };
    const url = this.baseUrl + '/Products/GetAllDisabledProducts';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllTaxMasters() {
    let url = this.baseUrl + '/Products/GetAllTaxMasters';
    return this.http.get(url);
  }

  public getAllOrdersForAdmin(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      userID: 0, //to get all user's orders
      isDateChecked: params.isDateChecked, //true,
      fromDate: params.fromDate, //"2023-07-26T12:55:45.586Z",
      toDate: params.toDate, //"2023-07-26T12:55:45.586Z",
      takeAll: params.takeAll, //true,
      skip: params.skip, //0,
      take: params.take, //0,
      key: params.key, //"",
      keyWord: params.keyWord, //"",
      orderStatus: params.orderStatus, //"",
      directBuyNo: params.directBuyNo, //0,
      unknownUserKey: params.unknownUserKey, //""
      saleType: "",
    }
    let url = this.baseUrl + "/Order/GetAllOrders";
    return this.http.post(url, sendingData, this.parseHeaders);
  }


  public getCategoryWiseSalesReport(paramsForCategory: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      key: paramsForCategory.key,
      keyWord: paramsForCategory.keyWord,
      takeAll: paramsForCategory.takeAll,
      skip: paramsForCategory.skip,
      take: paramsForCategory.take,
      isDateChecked: paramsForCategory.isDateChecked,
      fromDate: paramsForCategory.fromDate,
      toDate: paramsForCategory.toDate,
      userId: paramsForCategory.userId,
      status: paramsForCategory.status,
    }
    const url = this.baseUrl + '/ModReports/GetCategoryWiseSalesReport';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public GetProductWiseSalesReport(paramsBestSellingProducts: any) {
    let userDetails = this.getLoginDetails();
    let sendingData: any = {
      sellerID: 0,
      key: paramsBestSellingProducts.key,
      keyWord: paramsBestSellingProducts.keyWord,
      takeAll: paramsBestSellingProducts.takeAll,
      skip: paramsBestSellingProducts.skip,
      take: paramsBestSellingProducts.take,
      isDateChecked: paramsBestSellingProducts.isDateChecked,
      fromDate: paramsBestSellingProducts.fromDate,
      toDate: paramsBestSellingProducts.toDate,
      userId: paramsBestSellingProducts.userId,
      status: paramsBestSellingProducts.status,
      orderId: paramsBestSellingProducts.orderId,
      productId: paramsBestSellingProducts.productId,
      productCategoryId: paramsBestSellingProducts.productCategoryId,
    }
    var url = this.baseUrl + '/ModReports/GetProductWiseSalesReport';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllResellerOrdersByDateWise(params: any) {
    const loginDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: loginDetails.SellerID,
      key: params.key,
      keyword: params.keyWord,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      agentID: params.agentID,
      orderStatus: params.orderStatus,
      productId: params.productId,
    }
    let url = this.baseUrl + '/Order/GetAllResellerOrdersByDateWise';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getResellerOrdersForSeller(params: any) {
    const loginDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: loginDetails.SellerID,
      key: params.key,
      keyWord: params.keyWord,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
    }
    let url = this.baseUrl + '/Order/GetResellerOrdersForSeller';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateOrderStatusWithTrack(params: any) {
    let userDetails = this.getLoginDetails();
    let thirdData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      sellerID: 0,
      updatedBy: Number(userDetails.UserID),
      organisationID: thirdData?.OfferPlatformId ?? 0,
      updatedOn: new Date(),
      id: Number(params.id),
      customerName: params.customerName,
      phoneNumber: params.phoneNumber,
      // orderNumber: params.orderNumber,
      totalAmount: params.totalAmount,
      isPaid: params.isPaid,
      expectedDeliveryDate: params.expectedDeliveryDate,
      returnedProductsCount: params.returnedProductsCount,
      returnedAmount: params.returnedAmount,
      udf: params.udf,
      orderStatus: params.orderStatus,
      internalDescription: params.internalDescription,
      customerDescription: params.customerDescription,
    }

    let url = this.baseUrl + "/Order/UpdateOrderStatusWithTrack";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deliveryTrackShipment(params: any) {
    let url = `${this.baseUrl}/DeliveryPartner/DeliveryTrackShipment?deliveryUniqueId=${params.deliveryUniqueId}&deilveryPartner=${environment.deilveryPartner}`;
    return this.http.get(url, this.parseHeaders)
  }

  getOrderTrack(id: string) {
    let loginDetails = this.getLoginDetails();
    let sendingData = {
      id: id,
      updatedBy: loginDetails.ID
    }
    let url = this.baseUrl + '/Order/GetOrderTrack'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getOrderHistory(param: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      orderID: param.orderID,
      orderNumber: param.orderNumber,
    }
    let url = this.baseUrl + '/Order/GetOrderHistory'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllProducts(params: any) {
    let userDetails = this.getLoginDetails();
    let thirdData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      sellerID: 0,
      organisationID: thirdData?.OfferPlatformId ?? 0,
      createdBy: Number(userDetails.UserID),
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
    }
    let param = {
      key: "",
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: true,
      fromDate: "",
      toDate: "",
    }
    let url = this.baseUrl + "/Products/GetAllProducts";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public cancelPackageOrder(params: any) {
    let url = `${this.baseUrl}/DeliveryPartner/CancelPackageOrder?orderId=${params.orderId}&wayBill=${params.wayBill}&deilveryPartner=${params.deilveryPartner}`;
    return this.http.get(url, this.parseHeaders);
  }

  public generateShippingLabel(params: any) {
    let url = `${this.baseUrl}/DeliveryPartner/GenerateShippingLabel?wayBill=${params.wayBill}&deilveryPartner=${params.deilveryPartner}`;
    return this.http.get(url, this.parseHeaders)
  }

  public deliveryPickupLocationCreation(params: any) {
    const loginDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: Number(loginDetails.SellerID),
      createdBy: Number(loginDetails.UserID),
      registeredName: loginDetails.SellerName,
      deilveryPartner: params.deilveryPartner,
      phone: params.phone,
      city: params.city,
      state: params.state,
      name: params.name,
      pinCode: params.pinCode,
      address: params.address,
      country: params.country,
      email: params.email,
      returnAddress: params.returnAddress,
      returnPin: params.returnPin,
      returnCity: params.returnCity,
      returnState: params.returnState,
      returnCountry: params.returnCountry,
      id: 0,
      isIntegratedOnDeliveryPartner: true,
      partnerUniqueId: ""
    }
    let url = this.baseUrl + '/DeliveryPartner/DeliveryPickupLocationCreation';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getPickupLocations(params: any) {
    const loginDetails = this.getLoginDetails();
    let thirdData = this.getThirdPartyConnectionDetails();
    let sendingData = {
      sellerID: loginDetails.SellerID,
      organisationID: thirdData?.PaymentGatewayId ?? loginDetails.SellerID,
      createdBy: loginDetails.UserID,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
    }
    let url = this.baseUrl + '/DeliveryPartner/GetAllSellerPickUpLocation';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deliveryPickupLocationUpdation(params: any) {
    const loginDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: loginDetails.SellerID,
      createdBy: loginDetails.UserID,
      deilveryPartner: environment.deilveryPartner,
      id: params.id,
      phone: params.phone,
      city: params.city,
      state: params.state,
      name: params.name,
      pinCode: params.pinCode,
      address: params.address,
      country: params.country,
      email: params.email,
      registeredName: params.registeredName,
      returnAddress: params.returnAddress,
      returnPin: params.returnPin,
      returnCity: params.returnCity,
      returnState: params.returnState,
      returnCountry: params.returnCountry,
      isIntegratedOnDeliveryPartner: params.isIntegratedOnDeliveryPartner,
      partnerUniqueId: params.partnerUniqueId,
    }
    let url = this.baseUrl + '/DeliveryPartner/DeliveryPickupLocationUpdation';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteSellerPickUpAddress(params: any) {
    const loginDetails = this.getLoginDetails();
    let sendingData = {
      id: params.id,
      updatedBy: loginDetails.UserID
    }
    let url = this.baseUrl + '/DeliveryPartner/DeleteSellerPickUpAddress';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  setSellerRegistration(params) {
    let sendingData = {
      sellerID: params.SellerID,
      shopName: params.shopName,
      firstName: "",
      email: "",
      mobile: params.mobile,
      createdBy: 0,
      subDomainPath: params.subDomainPath,
      location: "",
      userName: params.userName,
      password: params.password,
      themeColour: "",
      pan: "",
      gstin: "",
      accountHolderAlias: "",
      accountHolderName: "",
      accountNumber: "",
      bankName: "",
      branch: "",
      ifsc: "",
      bankVerifiedFiles: "",
      sellerRegisterationAmount: 0,
      isSeller: true,
      isReSeller: false,
      integratePG: false,
    }
    let url = this.configService.getNoAuthUrl() + "/Seller/SuperAdminCreateSellerWithMinParamVTwo";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public adminLogin(params) {
    let sendingData = {
      UserName: params.UserName,
      Password: params.Password,
      UserType: "admin"
    }
    let url = this.configService.getLoginUrl() + '/User/AdminLogin';
    return this.http.post(url, sendingData, this.parseHeaders)
  }

  public authLogin(params: any, sellerUuid?: string) {
    const headers = new HttpHeaders({
      'X-Seller-Uuid': sellerUuid || ''
    });
    let url = this.configService.getLoginUrl() + '/Authentication/AdminLogin'
    let sendingData = {
      userName: params?.UserName,
      password: params?.Password,
      sellerId: params?.sellerId,
      UserType: params?.UserType,
    }
    return this.http.post(url, sendingData, { headers });
  }

  public refreshToken() {
    let url = this.configService.getLoginUrl() + '/Authentication/RefreshToken'
    return this.http.post(url, {});
  }

  public checkSubdomainExist(domain: string) {
    let url = this.configService.getNoAuthUrl() + '/Seller/CheckSubdomainExist?subDomain=' + domain;
    return this.http.get(url, this.parseHeaders);
  }

  public GetRegistrationFlowStatus(params: any) {
    var url = this.configService.getNoAuthUrl() + '/Order/GetRegistrationFlowStatusByPhoneNumber?PhoneNumber=' + params.PhoneNumber;
    return this.http.get(url, this.parseHeaders)
  }

  public getTermsAndConditionsForSeller(SellerID: any) {
    var url = this.baseUrl + '/Public/GetTermsAndConditionsForSellerBySellerId?SellerID=' + SellerID;
    return this.http.get(url, this.parseHeaders)
  }

  public GenerateOTPforAdmin(Username?: string) {
    if (!Username) {
      let userDetails = this.getLoginDetails();
      Username = userDetails.UserName;
    }
    var url = this.configService.getNoAuthUrl() + '/User/GenerateOTPForAdminUser?adminUsername=' + Username;
    return this.http.get(url, this.parseHeaders)
  }

  public InsertSellerSubDomainWithRegistrationStatus(params: any) {
    let url = this.configService.getNoAuthUrl() + '/Seller/InsertSellerSubdominWithRegistrationStatus'

    var sendingData = {
      phoneNumber: params.mobile,
      subDomain: params.SubDomainPath,
      shopName: params.ShopName,
      sellerID: params.SellerID,
      termsAndConditionVersionNumber: params.termsAndConditionVersionNumber,
      userAgentDetails: params.UserAgent

    }
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public SellerAgreeTermsAndCondtions(params: any) {
    let url = this.configService.getNoAuthUrl() + '/Seller/SellerAcceptTermsAndCondition'
    var sendingData = {
      sellerID: params.sellerID,
      termsAndConditionVersionNumber: params.termsAndConditionVersionNumber,
    }
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public resetPasswordforAdmin(params) {
    let url = this.configService.getNoAuthUrl() + '/User/ResetAdminPasswordUsingOTP'
    var sendingData = {
      otp: params.otp,
      password: params.Password,
      phoneNumber: params.UserName
    }
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  getOrderDetails(params: any) {
    let loginDetails = this.getLoginDetails();
    let sendingData = {
      SellerID: loginDetails.SellerID,
      ID: params.ID
    }
    let url = this.baseUrl + '/Order/GetOrderDetails';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getDeliveryChargeDetailsByProductId(productId: any) {
    let url = this.baseUrl + '/Products/GetDeliveryChargeDetailsByProductIDForSeller?ProductID=' + productId;
    return this.http.get(url, this.parseHeaders);
  }

  ForCopySellerProductsToNewSeller() {
    let loginDetails = this.getLoginDetails();
    let sendingData = {
      fromSellerId: 124,
      toSellerId: loginDetails.SellerID
    }
    let url = this.baseUrl + '/Seller/CopySellerProducts';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSellerDomainCategories() {
    let url = this.baseUrl + '/Seller/GetSellerDomainCategories';
    return this.http.get(url);
  }

  public getUserReturnList(params?: any) {
    const loginDetails = this.getLoginDetails();
    let url = this.baseUrl + `/Return/GetUserReturnList?sellerId=${0}&userId=${params?.userId ?? 0}&orderId=${params?.orderId ?? 0}`;
    if (params?.createdOn) {
      url += '&createdOn=' + params.createdOn;
    }
    return this.http.get(url);
  }

  public getAllReturn(params: any) {
    const loginDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: loginDetails.SellerID,
      key: params.key,
      keyWord: params.keyWord,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      orderStatus: params.orderStatus,
      userID: params.userID,
      directBuyNo: params.directBuyNo,
      unknownUserKey: params.unknownUserKey,
    }
    let url = this.baseUrl + '/Return/GetAllReturn';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  approveReturn(params: any) {
    let loginDetails = this.getLoginDetails();
    let productForReturn = [];
    for (let item of params.products) {
      let prod = {
        id: item.ID,
        productId: item.ProductId,
        requestedQty: item.RequestedQty,
        returnStatus: item.status,
        returnDescription: "",
        // isAccepted: (item.status=="Canceled") ? false : true,
        isAccepted: item.IsAccepted,
        isNew: false,
        acceptedQty: item.RequestedQty,
        returnAcceptedPrice: item.ReturnAcceptedPrice,

      }
      productForReturn.push(prod);
    }

    let sendingData = {
      sellerID: loginDetails.SellerID,
      orderId: params.orderId,
      discountedOnReturn: params.discountedOnReturn,
      userId: params.userId,
      products: productForReturn,
      createdBy: 0
    }

    let url = this.baseUrl + '/Return/SubmitReturnRequest';
    return this.http.put(url, sendingData, this.parseHeaders);
  }

  public getUsersForAdmin(params?: any) {
    const userDetails = this.getLoginDetails()
    const sendingData = {
      sellerID: 0,
      userType: 'user',
      keyWord: params?.keyword ?? '',
      skip: params?.skip ?? 0,
      take: params?.take ?? 0,
      takeAll: params?.takeAll ?? true,
    }
    const url = this.baseUrl + '/User/GetUsersForAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getShopsForAdmin(params?: any) {
    const userDetails = this.getLoginDetails()
    const sendingData = {
      sellerID: 0,
      userType: 'shop',
      keyWord: params?.keyword ?? '',
      skip: params?.skip ?? 0,
      take: params?.take ?? 0,
      takeAll: params?.takeAll ?? true,
    }
    const url = this.baseUrl + '/User/GetUsersForAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getCategoriesforDummyProducts() {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Seller/GetDummyProductCategories';
    return this.http.get(url);
  }

  public getProductListForDummyProducts(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      categoryID: params.categoryID,
      keyword: params.keyword,
      productsFor: params.productsFor,
      organisationID: params.OrganisationID,
      sellerID: 0,
      // userId: userDetails.UserID,
    }
    var url = this.baseUrl + '/Products/GetProducts';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  ForCopySellerProductsToNewSellerForDummyProducts(params: any) {
    let loginDetails = this.getLoginDetails();
    let sendingData = {
      // fromSellerId: 87,
      fromSellerId: params.SellerID,
      toSellerId: loginDetails.SellerID
    }
    let url = this.baseUrl + '/Seller/CopySellerProducts';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public insertIntoSellerListAtRegister(contactNumber: any) {
    var url = this.configService.getNoAuthUrl() + '/Seller/InsertIntoSellerEnqueryList?contactNumber=' + contactNumber;
    return this.http.get(url, this.parseHeaders)
  }

  public compareOTP(params) {
    let url = this.configService.getNoAuthUrl() + '/Order/CompareOTP?PhoneNumber=' + params.PhoneNumber + '&OTP=' + params.OTP;
    return this.http.get(url, this.parseHeaders);
  }

  public compareOTPWithStringReturn(params) {
    let url = this.configService.getNoAuthUrl() + '/Order/CompareOTPWithStringReturn?PhoneNumber=' + params.PhoneNumber + '&OTP=' + params.OTP;
    return this.http.get(url, this.parseHeaders);
  }

  public GenerateOTP(phonenumber) {
    let tempBaseUrl = this.baseUrl //change later if necessory
    var url = this.configService.getNoAuthUrl() + '/Order/GenerateOTP?PhoneNumber=' + phonenumber;
    return this.http.get(url, this.parseHeaders)
  }

  public updateDiscount(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      orderId: params.orderId,
      appliedDiscount: params.appliedDiscount,
      totalAmount: params.totalAmount,
      updatedBy: userDetails.UserID
    };
    let url = this.baseUrl + '/Order/UpdateOrderDiscount';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getUserWishlistForAdmin(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      createdOn: params.createdOn,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      keyWord: params.keyWord,
      orderStatus: params.orderStatus,
      userID: params.userID,
      directBuyNo: params.directBuyNo,
      unknownUserKey: params.unknownUserKey,
    };
    const url = this.baseUrl + '/UserWishList/GetUserWiseWishListForAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);

  }

  public getUserWishList(userId: number) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      userID: userId,
      directBuyNo: 0,
      sellerID: 0,
      organisationID: 0,
    };
    let url = this.baseUrl + "/UserWishList/GetUserWishList";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getDeliveryAddressByUser(userID: number) {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Order/GetDeliveryAddressByUser';
    let sendingData = {
      sellerId: 0,
      userID: userID,
    };
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllUserOrdersForAdmin(userId: number, params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      userID: userId, //to get user's orders
      isDateChecked: params.isDateChecked, //true,
      fromDate: params.fromDate, //"2023-07-26T12:55:45.586Z",
      toDate: params.toDate, //"2023-07-26T12:55:45.586Z",
      takeAll: params.takeAll, //true,
      skip: params.skip, //0,
      take: params.take, //0,
      key: params.key, //"",
      keyWord: params.keyWord, //"",
      orderStatus: params.orderStatus, //"",
      directBuyNo: params.directBuyNo, //0,
      unknownUserKey: params.unknownUserKey, //""
      saleType: "",
    }
    let url = this.baseUrl + "/Order/GetAllOrders";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getUserCart(userId: number, param: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      UserID: userId,
      SellerID: 0,
      takeAll: param.takeAll,
      skip: param.skip,
      take: param.take,
      DirectBuyNo: 0,
    };
    let url = this.baseUrl + '/Order/GetUserCart';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getdamagelist() {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      takeAll: true,
      isDateChecked: false,
      fromDate: "",
      toDate: "",
      organisationID: 0,
      createdBy: userDetails.UserID,
      sellerID: 0,
      productName: "",
    }
    let url = this.baseUrl + '/DamageProduct/GetAllDamageProducts';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteDamageProduct(id: number) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: id,
      updatedBy: userDetails.UserID
    };
    let url = this.baseUrl + '/DamageProduct/DeleteDamageProduct';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateDamageProduct(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      damageID: params.damageID,
      price: params.price,
      qty: params.qty,
      damageDescription: params.damageDescription,
      updatedBy: userDetails.UserID,
      updatedOn: params.updatedOn,
    }
    let url = this.baseUrl + '/DamageProduct/UpdateDamageProduct';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getUserAbandonCart(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      isAbandon: params.isAbandon,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      key: params.key,
    };
    const url = this.baseUrl + '/Order/GetUserAbandonCart';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getUsersAllReturn(userId: number, params: any) {
    const loginDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: loginDetails.SellerID,
      key: params.key,
      keyWord: params.keyWord,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      orderStatus: params.orderStatus,
      userID: userId,
      directBuyNo: params.directBuyNo,
      unknownUserKey: params.unknownUserKey,
    }
    let url = this.baseUrl + '/Return/GetAllReturn';
    return this.http.post(url, sendingData, this.parseHeaders);
  }


  public getreturnslistforreport(params: any) {
    const userDetails = this.getLoginDetails();
    let sendingData: any = {
      sellerID: 0,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      userId: params.userId,
      status: params.status,
      keyWord: params.keyWord,
    }
    let url = this.baseUrl + '/ModReports/getreturnslistforreport';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getCustomerWiseReport(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      userId: params.userId,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      key: params.key,
      keyWord: params.keyWord,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      status: params.status,
    }
    const url = this.baseUrl + '/ModReports/GetCustomerWiseReport';
    return this.http.post(url, sendingData);
  }

  public getDayWiseSales(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      userId: params.userId,
      status: params.status,
      keyWord: params.keyWord,
    }
    // https://servicenear.in/ecomapi/ModReports/GetDayWiseSalesReport
    let url = this.baseUrl + '/ModReports/GetDayWiseSalesReport';
    return this.http.post(url, sendingData, this.parseHeaders);
  }


  public GetTransactionFromIntegatedAccounts(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      reportFor: "admin",
      createdBy: 0,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      customerId: params.customerId,
      keyWord: params.keyWord,
    };
    let url = this.baseUrl + '/Reports/GetTransactionFromIntegatedAccountsWithDateFilter';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getBalancesFromIntegatedAccounts(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: 0,
      reportFor: "admin",
      createdBy: userDetails.UserID,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      customerId: params.customerId,
    };
    let url = this.baseUrl + '/Reports/GetBalancesFromIntegatedAccounts';
    return this.http.post(url, sendingData);
  }

  public generateUnpublishedStoreToken() {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      updatedBy: userDetails.UserID,
    }
    const url = this.baseUrl + '/Seller/GenerateUnpublishedStoreToken';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getThemesFromJSON() {
    const url = "assets/theme/themeData.json";
    return this.http.get(url);
  }

  public getSubscriptionPlans() {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0
    }
    const url = this.baseUrl + "/Subscription/GetSubscriptionPlans";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getStaffUsersForAdmin(params?: any) {
    const userDetails = this.getLoginDetails()
    const sendingData = {
      userType: 'staff',
      fromDate: '',
      toDate: '',
      isDateChecked: false,
      organisationID: 0,
      skip: params?.skip ?? 0,
      take: params?.take ?? 0,
      takeAll: params?.takeAll ?? true,
      keyWord: params?.keyword ?? ''
    }
    const url = this.baseUrl + '/User/GetUsersForAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getRegisterUser(params: any) {
    let userDetails = this.getLoginDetails();
    const socialMediaLinks = {
      facebook: params.socialMediaLinks?.facebook || '',
      whatsapp: params.socialMediaLinks?.whatsapp || '',
      twitter: params.socialMediaLinks?.twitter || '',
      instagram: params.socialMediaLinks?.instagram || ''
    };

    let sendingData = {

      firstName: params.firstName,
      lastName: params.lastName,
      mobileNo: params.mobileNo,
      username: params.username,
      password: params.password,
      sellerID: 0,
      email: params.email,
      isDisabled: true,
      showCardLayoutUI: true,
      designation: params.designation,
      ProfileImage: params.profileImage || '',
      state: params.state,
      country: params.country,
      pincode: params.pincode,
      landmark: params.landmark || '',
      district: params.district,
      address: params.address,
      socialMediaLinks: JSON.stringify(socialMediaLinks),
      userType: "staff",
      createdBy: userDetails.UserID,
      updatedBy: userDetails.UserID,
    };
    let url = this.baseUrl + '/User/RegisterUser';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public changeStaffUserStatus(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: params.id,
      status: params.status,
      updatedBy: userDetails.UserID
    }
    let url = this.baseUrl + '/User/DeleteUser';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateStaffUser(params: any) {
    let userDetails = this.getLoginDetails();
    const socialMediaLinks = {
      facebook: params.socialMediaLinks?.facebook || '',
      whatsapp: params.socialMediaLinks?.whatsapp || '',
      twitter: params.socialMediaLinks?.twitter || '',
      instagram: params.socialMediaLinks?.instagram || ''
    };
    let sendingData = {
      id: params.id,
      firstName: params.firstName,
      lastName: params.lastName,
      username: params.username,
      password: params.password,

      designation: params.designation,
      organisationID: 0,
      email: params.email,
      mobileNo: params.MobileNo,
      isDisabled: params.isDisabled,
      showCardLayoutUI: true,
      Designation: params.Designation,
      ProfileImage: params.ProfileImage,
      State: params.State,
      Country: params.Country,
      Pincode: params.Pincode,
      landmark: params.landmark || '',
      District: params.District,
      Address: params.Address,
      socialMediaLinks: JSON.stringify(socialMediaLinks),
    }
    let url = this.baseUrl + '/User/UpdateUser';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getThemeConfigurationJSON() {
    const url = "assets/theme/themeConfig.json";
    return this.http.get(url);
  }

  public getThemeDataJSON() {
    const url = "assets/theme/themeData.json";
    return this.http.get(url);
  }

  public updateSeoSettings(params: any) {
    const userDetails = this.getLoginDetails();
    let sendingData = {
      SellerId: 0,
      UpdatedBy: userDetails.UserID,
      OpenGraphImage: params.OpenGraphImage,
      SeoKeyWords: params.SeoKeyWords,
      SellerDescription: params.SellerDescription,
    }
    const url = this.baseUrl + '/Seller/UpdateSeoSettings';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public createSubscription(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      createdBy: userDetails.UserID,
      updatedBy: userDetails.UserID,
      updatedOn: this.toDateString(new Date()),
      createdOn: this.toDateString(new Date()),
      subscriptionID: params.subscriptionID,
      paymentID: params.paymentID,
      paymentAmount: params.paymentAmount,
      paymentType: params.paymentType,
    }
    const url = this.baseUrl + "/Subscription/CreateSubscription";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSellerLegalDocumentt(parm: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      documentType: parm.documentType,
      showLegalEntityidKey: true,
    };
    let url = this.baseUrl + '/Seller/GetSellerLegalDocument';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public GetSellerLegalDetailsForSeller(params: any) {
    let url = this.baseUrl + '/Seller/GetLegalDocumentForSeller?DocumentType=' + params;
    return this.http.get(url, this.parseHeaders);
  }

  public UpdateSellerLegal(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      UpdatedBy: userDetails.UserID,
      documentType: params.documentType,
      documentData: params.documentData,
      title: params.title,
      updatedOn: ''
    }
    const url = this.baseUrl + '/Seller/UpdateSellerLegalDocuments';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public changeSellerSubdomain(params: any) {
    const userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      UpdatedBy: userDetails.UserID,
      subdomainpath: params.subDomainPath,
      updatedOn: ''
    }
    const url = this.baseUrl + '/Seller/ChangeSellerSubDomain';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deactivateActivateSellerProfile(params: any) {
    const userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      updatedBy: userDetails.UserID,
      deactivateStatus: params.deactivateStatus,
    }
    const url = this.baseUrl + '/Seller/DeactivateAndActivateSellerProfile';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public userDevice() {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Seller/getuserdevices';
    let sendingData = {
      id: userDetails.UserID,
      updatedBy: 0
    };
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public revokeToken(token: string) {
    const url = this.configService.getLoginUrl() + '/Authentication/RevokeToken';
    let sendingData = {
      RefreshToken: token
    };
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public DeleteSellerProfile() {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      updatedBy: userDetails.UserID,
    }
    const url = this.baseUrl + '/Seller/DeleteSellerProfile';
    return this.http.post(url, sendingData, this.parseHeaders);
  }



  public getOnBoardingThemeConfigurationJSON() {
    const url = "assets/Onboarding/OnBoardingthemeConfig.json";
    return this.http.get(url);
  }

  public getOnBoardingThemeDataJSON() {
    const url = "assets/Onboarding/OnBoardingData.json";
    return this.http.get(url);
  }

  public SaveSellerOnBoardingDetails(params: any) {
    let userDetails = this.getLoginDetails();
    const address = `${params.addressLine1}, ${params.addressLine2}`;
    let sendingData = {
      sellerID: 0,
      companyName: params.companyName,
      gstNumber: params.gstNumber,
      customerCarePhoneNumber: params.customerCarePhoneNumber,
      email: params.email,
      companyLogo: params.companyLogo,
      address: address,
      city: params.city,
      district: params.district,
      state: params.state,
      country: params.country,
      pinCode: params.pinCode,
      google: params.google,
      facebook: params.facebook,
      instagram: params.instagram,
      youtube: params.youtube,
      externalWebsite: params.externalWebsite,
      showLandingSiteFirst: params.showLandingSiteFirst,
      storeThemeColor: params.storeThemeColor,
      font: params.font,
      homePage: params.homePage,
      menubar: params.menubar,
      footer: params.footer,
      updatedBy: userDetails.UserID,
    };
    let url = this.baseUrl + '/Seller/SaveSellerOnBoardingData';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public SaveOnBoardingStatus(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      onBoardingStatus: params.onBoardingStatus,
      updatedBy: userDetails.UserID,
    };
    let url = this.baseUrl + '/Seller/SaveSellerOnBoardingStatus';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSellerOnBoardingFlowStatus() {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Seller/GetSellerOnBoardingStatus?SellerID=' + 0;
    return this.http.get(url);
  }

  public updateSellerThemeDetailsOnBoarding(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      SellerId: 0,
      UpdatedBy: userDetails.UserID,
      SellerName: params.sellerName,
      CustomerCare: params.customerCare,
      SubDomain: params.subDomain,
      SellerLogo: params.sellerLogo,
      SellerIcon: params.sellerIcon,
      GSTNumber: params.gstNumber,
      FavIcon: params.favIcon,
      Address: params.address,
      Addressline1: params.addressLine1,
      City: params.city,
      State: params.state,
      District: params.district,
      Country: params.country,
      Pincode: params.pincode,
      ThirdPartyConnectionDetails: params.thirdPartyConnectionDetails,
      SellerThemeVersion: params.sellerThemeVersion,
      Color: params.color,
      ColorSecondary: params.colorSecondary,
      FontColor: params.fontColor,
      Font: params.font,
      TopBanner: params.topBanner,
      FooterBanner: params.footerBanner,
      Featured: params.featured,
      TopDiscounted: params.topDiscounted,
      Trending: params.trending,
      TopOrdered: params.topOrdered,
      TopOffers: params.topOffers,
      RecentlyViewed: params.recentlyViewed,
      IsPublished: params.isPublished,
      PickUpEnabled: params.pickUpEnabled,
      RefferalCode: params.refferalCode,
      LandingPage: params.landingPage,
      Cod: params.cod,
      PayNow: params.payNow,
      EnableOrderEdit: params.enableOrderEdit,
      OrderReturnMode: params.orderReturnMode,
      CustomerTheme: params.customerTheme,
      ShowSimilarProducts: params.showSimilarProducts,
      SeoKeyWords: params.SeoKeyWords,
      SellerDescription: params.SellerDescription,
      OpenGraphImage: params.OpenGraphImage,
      IsDummyEnabled: params.IsDummyEnabled,
      ShowLandingSiteFirst: params.ShowLandingSiteFirst,
      GoogleAnalytics: params.GoogleAnalytics,
      LimitCustomerRegistration: params.LimitCustomerRegistration,
      ShowProductListInHome: params.ShowProductListInHome,
      ShowProductPriceAuthorizedCustomers: params.ShowProductPriceAuthorizedCustomers,
      ReturnAllProducts: params.ReturnAllProducts,
      ReturnEachProduct: params.ReturnEachProduct,
      ShowTransactionList: params.ShowTransactionList,
      ShowMRP: params.ShowMRP,
      ExternalLinkAndDirectBuynow: params.ExternalLinkAndDirectBuynow,
      ExternalLinkButtonLabel: params.ExternalLinkButtonLabel,
      DirectWhatsapp: params.DirectWhatsapp,
      storeEnable: params.storeEnable,
      websiteEnable: params.websiteEnable,
      dvCardEnable: params.dvCardEnable,
      menuCardEnable: params.menuCardEnable,
      catalogueEnable: params.catalogueEnable,

    };


    let sendingDataString = JSON.stringify(sendingData);


    let payload = {
      SellerThemeDetails: sendingDataString
    };

    let url = this.baseUrl + '/Seller/UpdateSellerThemeDetails';
    return this.http.post(url, payload, this.parseHeaders);
  }

  public updateSellerProfileOnBoading(params: any) {
    let userDetails = this.getLoginDetails();
    const socialMediaLinks = {
      facebook: params.facebook,
      youtube: params.youtube,
      gmail: params.gmail,
      instagram: params.instagram,
      googleBusiness: params.googleBusiness,
      externalWebsite: params.externalWebsite
    };
    const sendingData = {
      sellerID: 0,
      updatedBy: userDetails.UserID,
      sellerName: params.sellerName,
      customerCare: params.customerCare,
      city: params.district,
      address: params.address,
      socialMediaLinks: JSON.stringify(socialMediaLinks),
      gstNumber: params.gstNumber,
      companyLogo: params.companyLogo,
      addressline1: params.addressLine1,
      state: params.state,
      country: params.country,
      pincode: params.pincode,
    }
    let url = this.baseUrl + '/Seller/UpdateSellerProfile';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public GetDeliveryCharge() {
    let SELLERID = this.getLoginDetails().SellerID;
    const url = this.baseUrl + '/Products/GetDeliveryChargesBySeller?SellerID=' + 0;
    return this.http.get(url)
  }

  public deliverytype(productId: number) {
    let url = `${this.baseUrl}/Products/GetDeliveryChargeDetailsByProductID?ProductID=${productId}`;
    return this.http.get(url)
  }

  public getSecondBannerImages() {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Seller/GetSecondBannerImagesBySeller?SellerID=' + 0;
    return this.http.get(url);
  }

  public uploadUsingFileStream(formData: FormData) {
    const url = `${this.baseUrl}/FileUpload/UploadUsingFileStream`;
    return this.http.post(url, formData);
  }

  public insertOrUpdateSellerSecondBanner(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      id: params.id ?? 0,
      secondBannerImage: params.secondBannerImage,
      bannerFor: params.bannerFor,
      updatedBy: userDetails.UserID,
      createdBy: userDetails.UserID,
    }
    let url = this.baseUrl + '/Seller/InsertOrUpdateSellerSecondBanner';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteSecondBannerImage(item: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerID: 0,
      id: item.ID,
      updatedBy: userDetails.UserID,
    }
    let url = this.baseUrl + '/Seller/DeleteSecondBannerImage';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public convertUnixDate(unixTimestamp: number) {
    // Convert to milliseconds and create a Date object
    const date = new Date(unixTimestamp * 1000);
    // Format the date
    const formattedDate = date.toLocaleString();
    return this.convertDate(formattedDate)
  }

  public convertDate(date: any) {
    return moment(date).format("DD MMM YY, hh:mm a");
  }

  public updateSellerStatus(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: params.ID,
      status: params.IsActive,
      updatedBy: userDetails.ID
    };
    let url = this.baseUrl + '/Seller/SuperAdminUpdateSellerStatus';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getRatingsAndReviewsBySeller(params: any) {
    const sendingData = {
      searchKey: params.searchKey,
      fromDate: 0,
      toDate: 0,
    }
    let url = this.baseUrl + '/Rating/GetProductRatingAndReviewsBySeller';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public hideReview(params: any) {
    let sendingData = {
      reviewId: params.reviewId,
    }
    let url = this.baseUrl + '/Rating/HideReview?reviewId=' + params.reviewId;
    return this.http.post(url, this.parseHeaders);
  }

  public thirdPartyLogin(userKey: string) {
    const sendingData = {
      checkWithTempKey: true,
      tempKey: userKey
    }
    const url = this.configService.getLoginUrl() + '/Authentication/AdminLogin';
    return this.http.post(url, sendingData);
  }

  public getUserProfile(userID: number) {
    let sendingData = {
      userID: userID,
    };
    let url = this.baseUrl + '/User/GetUserProfile';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public createCustomer(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      firstName: params.customerFirstName,
      lastName: params.customerLastName,
      mobileNo: params.phone,
      state: params.state,
      country: params.country,
      pincode: params.pin,
      landmark: params.landmark,
      district: params.district,
      address: params.address,
      userType: params.userType,
      createdBy: userDetails.UserID,
      shopName: params.customerFirstName,
      branchCode: '',
      password: 0,
    }

    let url = this.baseUrl + '/User/SellerCreateCustomerOrShopByType';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateCustomer(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: params.customerID,
      firstName: params.customerFirstName,
      lastName: params.customerLastName,
      mobileNo: params.phone,
      state: params.state,
      country: params.country,
      pincode: params.pin,
      landmark: params.landmark,
      district: params.district,
      address: params.address,
      userType: params.userType,
      createdBy: userDetails.UserID,
      shopName: params.customerFirstName,
      branchCode: '',
      password: 0,
      updatedBy: userDetails.UserID,
    }

    let url = this.baseUrl + '/User/SellerUpdateCustomerOrShopByType';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteCustomerorShop(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: params.id,
      userType: params.userType,
      updatedBy: userDetails.UserID
    }
    let url = this.baseUrl + '/User/SellerDeleteCustomerOrShopByID';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public SaveSellerSubdominAndDetails(params: any) {
    var sendingData = {
      subDomain: params.subDomain,
      shopName: params.shopName,
      uniqueIdentifier: params.uniqueIdentifier,
    }
    let url = this.baseUrl + '/Seller/SaveSellerSubdominAndDetails';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public uploadFileStream(formData: FormData) {
    const url = this.baseUrl + '/FileUpload/UploadUsingFileStream';
    return this.http.post(url, formData);
  }

  public SuperAdminCreateSellerWithMinDetails(params: any) {
    let sendingData = {
      mobile: params.mobile,
      userName: params.userName,
      password: params.password,
      userAgentDetails: params.UserAgent,
      termsAndConditionVersionNumber: params.termsAndConditionVersionNumber,
      shopName: "",
      integratePG: false,
      isReSeller: false,
      isSeller: true,
    }
    const url = this.baseUrl + "/Public/SuperAdminCreateSellerWithMinDetails";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getUsersAndShopsForAdmin(params: any) {
    const userDetails = this.getLoginDetails()
    const sendingData = {
      sellerID: 0,
      userType: params.userType,
      keyWord: ''
    }
    const url = this.baseUrl + '/User/GetUsersForAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public saveTransactionByConfiguration(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      createdBy: userDetails.UserID,
      customerName: params.customerName,
      sellerName: "",
      customerID: params.customerID,
      // discount: params.discount ? params.discount : 0,
      totalAmount: params.totalAmount ? params.totalAmount : 0,
      paymentModes: params.paymentModes ? params.paymentModes : 0,
      orderId: params.orderId ? params.orderId : 0,
    };
    let url = this.baseUrl + '/Accounts/SaveTransactionByConfiguration';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getPaymentModesBySeller() {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Accounts/GetPaymentModesBySeller';
    return this.http.get(url);
  }

  public getUserListSummary(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData: any = {
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: false,
      fromDate: moment(params.fromDate, 'yyyy-MM-ddThh:mm:ss').add(1, 'day'),
      toDate: moment(params.toDate, 'yyyy-MM-ddThh:mm:ss').add(1, 'day'),
      sellerID: userDetails.SellerID,
      organisationID: 0,
      userType: params.userType
    };
    let url = this.baseUrl + '/User/GetUserListSummary';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllPrivilegesForAdminBySellerID() {
    let url = this.baseUrl + '/Seller/GetAllPrivilegesForAdminBySellerID';
    return this.http.post(url, this.parseHeaders);
  }

  public GetProductTags() {
    const url = this.baseUrl + '/Products/GetProductTags';
    return this.http.get(url)
  }

}